export const contactSection = 0;
export const shippingSection = 1;
export const paymentSection = 2;
